import { AppointmentName, OutsideAppointmentName } from '@src/components/ReasonForVisit/ReasonForVisit.helpers';
import { AppointmentTypesDocument, type AppointmentType } from '@src/lib/__generated/vetspire/sdk';
import { queryClient } from '@src/utils/query-client';

export default async function FetchAppointmentTypes() {
	const vetspireApppointmentTypes: { appointmentTypes: AppointmentType[] } = await queryClient({
		query: AppointmentTypesDocument,
	});

	const appointmentNameSet: Set<string> = new Set(
		Object.values(AppointmentName).filter((name) => name !== AppointmentName.Urgent)
	);
	const scheduleSupportedAppointmentTypes = vetspireApppointmentTypes?.appointmentTypes?.filter((appointmentType) => {
		return appointmentType.name && appointmentNameSet.has(appointmentType.name);
	});

	const outsideAppointmentNameList: string[] = Object.values(OutsideAppointmentName);
	const nonScheduleSupportedAppointmentTypes = vetspireApppointmentTypes?.appointmentTypes?.filter(
		(appointmentType) => {
			return appointmentType.name && outsideAppointmentNameList.includes(appointmentType.name);
		}
	);

	return { scheduleSupportedAppointmentTypes, nonScheduleSupportedAppointmentTypes };
}
